<div class='previewModal'>
    <div class="modal-header">
        <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.modal.title' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
      <div class='row'>
        <div class='form-group col-4' style='margin-left: 10px'>
            <input type="radio" class="form-check-input" id='radio1' [(ngModel)]="custom" [value]='false' [checked]='!custom' (change)='selectedEmail=""'>
            <label  class="form-check-label" >{{'invoices.modal.existing' | translate}}</label>

        </div>
        <div class='form-group col-auto'>
            <input type="radio" class="form-check-input" id='radio1' [(ngModel)]="custom" [value]='true'>
            <label  class="form-check-label" >{{'invoices.modal.custom' | translate}}</label>
        </div>
      </div>
      <ng-container *ngIf='!custom; else insert'>
        <div class='row'>
          <div class='form-group col-auto' >
            <label  class="form-check-label"  > <b>{{'placeholder.searchBy' | translate}}:</b></label>
          </div>
          <div class='form-group col-auto' style='margin-left: 10px'>
             
              <input type="radio" class="form-check-input" id='radio2'  [(ngModel)]="filter" value="denominazione">
              <label  class="form-check-label" >{{'configuration.rubrica.table.den' | translate}}</label>

          </div>
          <div class='form-group col-auto'>
              
              <input type="radio" class="form-check-input" id='radio2' [(ngModel)]="filter" value="partita_iva">
              <label  class="form-check-label" >{{'configuration.rubrica.table.piva' | translate}}</label>
          </div>
        </div>
        <div class="row">
          <div class='form-group'>
              <div class="input-group">
                  <input #src type="text" class="form-control" [placeholder]="'placeholder.searchByName' | translate" aria-label="Cerca per nome"  aria-describedby="basic-addon1" (keyup.enter)="searchAddress(src.value)">
                  <span class="input-group-text" id="basic-addon1" (click)="searchAddress(src.value)"><i class="bi bi-search" [ngbTooltip]="'tooltip.search' | translate"></i></span>
                  <ng-container *ngIf="search && addresses;">
                      <div class='table-wrap'  *ngIf="addresses.length > 0; else noRes" >
                        <table class="table" >
                          <thead>
                            <tr >
                              <th></th>
                              <th scope="col" style="cursor: pointer;">{{'configuration.rubrica.table.den' | translate}}</th> 
                              <th scope="col">Email</th>
                              
                            </tr>
                          </thead> 
                          <tbody>
                            <tr *ngFor="let u of addresses" >
                              <td>
                                <input type="checkbox" class="form-check-input" style="margin-left: 5px;"
                                       [checked]="getEmail(u.json_data)==selectedEmail && addressId==u.id " (click)='selectAddress(getEmail(u.json_data, u.id))'>
                              </td>
                              <td>
                                {{u.denominazione}}
                              </td>
                              <td>
                                {{getEmail(u.json_data)}}
                              </td>
                                                             
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    
                      <ng-template #noRes>
                        <div>
                          <ngb-toast [autohide]="false" class="warning">
                              <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                              {{'general.noResults' | translate}}
                          </ngb-toast>
                        </div>
                      </ng-template>
                    </ng-container>
              </div>
          </div>
      </div>
      </ng-container>
      <ng-template #insert>
        <div class="form-group">
          <label class="roboSubTitle" for="address">Email</label>
          <input type="text" class="form-control" id="address" placeholder="Email" [(ngModel)]="selectedEmail">
      </div>
      </ng-template>
       
        
        
        
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
        <button type="button" class="btn btn-outline-dark" (click)="sendEmail()">{{ 'general.send' | translate }}</button>
    </div>
    </div>